import react from "react";
import axios, { Method } from "axios";

const request = (method: Method, url: string, params?: any, config?: any) => new Promise<any>((resolve, reject) => {
    if (method.toLowerCase() == "get" && params) {
        let hasParams = url.indexOf("?") > -1;
        for (let name in params) {
            url += (hasParams ? "&" : "?") + name + "=" + encodeURIComponent(params[name]);
        }
    }
    const _config = Object.assign({
        method: method,
        responseType: "json",
    }, params ? { data: params } : {}, config);
    // console.log("REQUEST",url,_config);
    axios(url, _config).then((res: any) => ProcessResponse(res, resolve)).catch((err: any) => processError(err, reject));
})

const ProcessResponse = (res: any, resolve: (res: any) => void) => {
    // console.log("RESPONSE",res,resolve);
    if (res.headers["replacement-token"]) {
        let new_token = res.headers["replacement-token"];
        if (res.data?.token) {
            new_token = res.data?.token
        }
        // console.log("SET NEW TOKEN", new_token);
        api.setToken(new_token);
    }
    resolve(res);
};

const processError = (err: any, reject: (err: any) => void) => {
    reject(err);
};

type API={
    get: (url: string, config?: any) => Promise<any>,
    post: (url: string, params?: any, config?: any) => Promise<any>,
    put: (url: string, params?: any, config?: any) => Promise<any>,
    delete: (url: string, config?: any) => Promise<any>,
    head: (url: string, config?: any) => Promise<any>,
    setToken: (token:string) => void,
    deleteToken: () => void,
    token: string
};

//@ts-ignore
const api:API = {
    get: (url: string, config?: any) => request("get", url, undefined, config),
    post: (url: string, params?: any, config?: any) => request("post", url, params, config),
    put: (url: string, params?: any, config?: any) => request("put", url, params, config),
    delete: (url: string, config?: any) => request("delete", url, undefined, config),
    head: (url: string, config?: any) => request("head", url, undefined, config),
    setToken: (token: string) => {
        if (localStorage.getItem("login")) {
            localStorage.setItem("access_token", token);
        } else {
            sessionStorage.setItem("access_token", token);
        }
    },
    deleteToken: () => {
        localStorage.removeItem("access_token");
        sessionStorage.removeItem("access_token");
    },
};

Object.defineProperty(api, "token", { 
    get: () => {
        return sessionStorage.getItem("access_token") || localStorage.getItem("access_token") || "";
    }
});

export default api;
